export default __webpack_public_path__ + "static/media/evernote.e3b22adb.png";